<template>
  <div class="life-wrapper">
    <Title title="九吨生活"></Title>
    <div class="page6-box">
      <div class=" swiper7">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in list" :key="index">
            <img :src="item.resource" class="img" alt="">
            <!-- <div class="text-box">
              <h1 class="title">{{ item.title }}</h1>
              <p class="desc">{{ item.subTitle }}</p>
            </div> -->
          </div>
        </div>
      </div>
      <!-- 操作按钮 -->
      <div class="cutover ajc space-between">
        <div class="left ajc" @click="less" v-if="current != 0">
          <img src="@/assets/img/mobile/20.png" class="right-icon" alt="">
        </div>
        <div v-else class="ajc">
          <img src="@/assets/img/mobile/18.png" class="right-icon" alt="">
        </div>
        <div class="number"><span>{{ current + 1 }}</span> / {{ list.length }}</div>
        <div class="right ajc" @click="add" v-if="current + 1 < list.length">
          <img src="@/assets/img/mobile/21.png" class="right-icon" alt="">
        </div>
        <div v-else class="ajc">
          <img src="@/assets/img/mobile/19.png" class="right-icon" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/js/swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import Title from '@/components/mobile/Title'
export default {
  components: {
    Title
  },
  data() {
    return {
      swiperExaLife: null, // swiper 实例
      current: 0,
      list: []
    }
  },
  mounted() {
    this.getData()

  },
  methods: {
    async getData() {
      const [err, res] = await this.$http.get('life')
      if (err) return
      this.list = res.list
      this.$nextTick(() => {
        this.initSwiper();
      })
    },
    less() {
      if (this.current > 0) {
        this.current -= 1
        this.swiperExaLife.slideToLoop(this.current)
      }
    },
    add() {
      if (this.current + 1 < this.list.length) {
        this.current += 1
        this.swiperExaLife.slideToLoop(this.current)
      }

    },
    initSwiper() {
      const _this = this
      this.swiperExaLife = new Swiper(".swiper7", {
        slidesPerView: 2,
        spaceBetween: 30,
        slidesOffsetAfter: 50,
        width: 500,
        // maxBackfaceHiddenSlides: 2,
        // direction: "vertical", // 垂直切换选项
        loop: true,
        loopAdditionalSlides: 1,
        on: {
          // 当轮播切换的时候
          slideChange: function () {
            _this.current = this.realIndex
          },
        }
      });
    }
  }

}
</script>

<style scoped lang="less">
.life-wrapper {
  position: relative;
  background: #FFF;
  padding: 1.76rem .5333rem .5333rem .5333rem;
  color: #000000;
  font-size: .2667rem;
  box-sizing: border-box;
  overflow: hidden;
}

.page6-box {
  margin-top: 2.5867rem;
  // overflow: hidden;
  // border: 1px solid;


  .swiper-slide {
    height: 4.2667rem;
    // width: 5.76rem !important;
    // border: 1px solid red;
    // margin-right: -20% ;


    .img {
      width: 100% !important;
      height: 3.0933rem;
      border-radius: .2667rem;
      margin-bottom: .1333rem;
      object-fit: cover;
      display: block;
    }

    .text-box {
      padding-left: .2133rem;
      box-sizing: border-box;
    }

    .title {
      font-size: .3733rem !important;
      margin-bottom: .2rem;
    }

    .desc {
      color: #666;
      font-size: .2667rem;
    }
  }
}

.cutover {
  width: 3.4rem;
  margin: 2.6667rem auto 0;

  .right-icon {
    width: .2667rem;
    height: .2667rem;
  }

  .number {
    font-weight: bold;

    span {
      font-size: .3733rem;
      color: #E28A2B;
    }
  }

  .right,
  .left {
    width: 0.9rem;
    height: 0.9rem;
    background: #E28B2B;
    box-shadow: 0 .1333rem .5333rem rgba(226, 139, 43, 0.5);
    border-radius: .6667rem;
    color: #FFF;
  }
}
</style>